import React, {useMemo} from 'react';
import colors from '../../constants/colors';
import scaleSize, {isTablet} from '../../utils/scaleSize';
import WebAudioPlayer from '../WebAudioPlayer';
import './CustomChatBubble.css';

interface CustomChatBubbleProps {
  isOwnMessage: boolean;
  content?: string;
  textColor?: string;
  audioUri?: string;
  isLastBubble?: boolean;
  stopAudio?: boolean;
  hidetext?: boolean;
  contentBaseUrl?: string;
}

const parseHighlightedContent = (content: string) => {
  const regex = /\{(.*?)\}/g;
  const parts: {value: string; isHighlight: boolean}[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push({
        value: content.substring(lastIndex, match.index),
        isHighlight: false,
      });
    }
    parts.push({value: match[1], isHighlight: true});
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < content.length) {
    parts.push({value: content.substring(lastIndex), isHighlight: false});
  }

  return parts;
};

const CustomChatBubble: React.FC<CustomChatBubbleProps> = ({
  isOwnMessage,
  content,
  textColor,
  audioUri,
  isLastBubble = false,
  stopAudio = false,
  hidetext = false,
  contentBaseUrl,
}) => {
  const trimmed = content?.trim();
  const parts = useMemo(
    () => (trimmed ? parseHighlightedContent(trimmed) : []),
    [trimmed],
  );

  if (!trimmed) {
    return null;
  }

  const marginStyle: React.CSSProperties = {
    marginLeft: isOwnMessage ? (isTablet() ? scaleSize(30) : scaleSize(60)) : 0,
    marginRight: isOwnMessage
      ? 0
      : isTablet()
        ? scaleSize(30)
        : scaleSize(100),
  };

  return (
    <div className="web-chat-bubble-wrap" style={marginStyle}>
      {!hidetext && (
        <div
          className={`web-chat-bubble ${
            isOwnMessage ? 'web-chat-bubble-own' : 'web-chat-bubble-other'
          }`}>
          <p className="web-chat-bubble-text" style={{color: textColor}}>
            {parts.map((part, index) =>
              part.isHighlight ? (
                <span key={index} className="web-chat-highlight">
                  {part.value}
                </span>
              ) : (
                <span key={index}>{part.value}</span>
              ),
            )}
          </p>
        </div>
      )}
      {audioUri && !isLastBubble && (
        <WebAudioPlayer
          uri={audioUri}
          stopAudioPlayer={stopAudio}
          contentBaseUrl={contentBaseUrl}
        />
      )}
    </div>
  );
};

export default CustomChatBubble;
